import { Component, Input } from '@angular/core';

import { VtmnPlayIconTypeEnum } from './enums/vtmn-play-icon-type.enum';

@Component({
  selector: 'vtmn-play-icon',
  templateUrl: './vtmn-play-icon.component.html',
  styleUrls: ['./vtmn-play-icon.component.scss'],
})
export class VtmnPlayIconComponent {
  @Input() public name? = VtmnPlayIconTypeEnum.ArrowDown;
  @Input() public width? = 24;
  @Input() public height? = 24;
  // More complex styling can be applied to the svg
  // https://www.npmjs.com/package/angular-svg-icon?activeTab=readme#usage-with-angular-universal
}
